{
"FUEL-PLACES--PLACES": "Lugares Registrados",
"FUEL-PLACES--SELECT": "Estos lugares pueden registrarse mediante el inicio de sesión web. Seleccione una dirección",
"FUEL-PLACES--SEARCH": "Buscar",
"FUEL-PLACES--NOT-FOUND": "No se encontró ninguna dirección"
}